// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 179 ? "main" : chunkId) + "." + {"160":"d3a65e4b5830dc71eb5a","179":"5c31c9c949198d704bf4"}[chunkId] + ".css";
};